import idx from 'idx';
import moment from 'moment';
moment.locale('es-MX');

const base_url = process.env.REACT_APP_API;

async function getTestQuestions(userToken) {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${userToken}`);
  try {
    const response = await fetch(
      `${base_url}/api/v1/exam`,
      {
        method: "GET",
        headers: myHeaders,
      }
    );
    const resp = await response.json();
    return resp;
  } catch (err) {
    console.error(err);
  }
}

async function sendQuestionAnswer(userToken, answer) {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${userToken}`);

  try {
    const response = await fetch(
      `${base_url}/api/v1/exam/answer`,
      {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
        body: JSON.stringify(answer),
      }
    );
    //const resp = await response.json();
    return response;
  } catch (err) {
    console.error(err);
  }
}

function sendVideo(userToken, videoObject) {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${userToken}`);

  try {
    fetch(
      `${base_url}/api/v1/exam/answer/video`,
      {
        method: "PATCH",
        headers: myHeaders,
        body: JSON.stringify(videoObject),
      }
    );
  } catch (error) {
    console.error(error);
  }
}

function sendImageAnswer(userToken, videoObject) {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${userToken}`);

  try {
    fetch(
      `${base_url}/api/v1/exam/answer/image`,
      {
        method: "PATCH",
        headers: myHeaders,
        body: JSON.stringify(videoObject),
      }
    );
  } catch (error) {
    console.error(error);
  }
}

async function sendSnap(userToken, imageObject) {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${userToken}`);

  try {
    const response = await fetch(
      `${base_url}/api/v1/exam/snap`,
      {
        method: "PATCH",
        headers: myHeaders,
        body: JSON.stringify(imageObject),
      }
    );
    const resp = await response.json();
    return resp;
  } catch (error) {
    console.error(error);
  }
}

///////nuevos/////////////

export const getEvalutionStatus = async () => {
  try {
    const response = await fetch(
      `${base_url}/api/v1/exam/active`,
      {
        method: "GET"
      }
    );
    const resp = await response.json();
    return resp;
  } catch (err) {
    console.error(err);
  }
};

export const getCheckNetwork = async () => {
  try {
    const response = await fetch(
      `${base_url}/api/v1/exam/chrome`,
      {
        method: "GET"
      }
    );
    const resp = await response.json();
    return resp;
  } catch (err) {
    console.error(err);
  }
};

export const getCheckMicrophone = async () => {
  try {
    const response = await fetch(
      `${base_url}/api/v1/exam/audio`,
      {
        method: "GET"
      }
    );
    const resp = await response.json();
    return resp;
  } catch (err) {
    console.error(err);
  }
};

export const startAttendance = async (userToken, blob ,webp) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${userToken}`);

  const data = {
    started_at: `${moment(new Date()).format('DD-MM-YYYY')} ${moment(new Date()).format('hh:mm:ss')}`
  };

  try {
    const response = await fetch(
      `${base_url}/api/v1/exam`,
      {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(data),
      }
    );
    const resp = await response.json();
    if (response.status === 201 || response.status === 200) {
      sendImageAttendance(userToken, webp);
      sendImageAttendance(userToken, blob);
    }
    return convertAttendance(resp);
    //return resp;
  } catch (err) {
    console.error(err);
  }
}

export const sendImageAttendance = (userToken, webp) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${userToken}`);

  const data = {
    image: webp
  };

  try {
    fetch(
      `${base_url}/api/v1/exam/image`,
      {
        method: "PATCH",
        headers: myHeaders,
        body: JSON.stringify(data),
      }
    );

  } catch (err) {
    console.error(err);
  }
}

async function getAttendance(userToken) {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${userToken}`);
  try {
    const response = await fetch(
      `${base_url}/api/v1/exam`,
      {
        method: "GET",
        headers: myHeaders,
      }
    );
    const resp = await response.json();
    return convertAttendance(resp);
  } catch (err) {
    console.error(err);
  }
}

const convertAttendance = (object) => {
  if(idx(object, _ => _.exam)){
    const { results, score, finished_at, certificate_url, evaluations_left } = object.exam;

    const newObject = {
      results,
      score,
      finished_at,
      user_certificate: certificate_url,
      evaluations_left,
      evaluation: {
        name: '',
        questions_count: idx(object, _ => _.questions.length),
        questions: idx(object, _ => _.questions) || []
      }
    }
    return newObject;
  } else return {};
};



export { getTestQuestions, sendQuestionAnswer, sendVideo, sendImageAnswer, sendSnap, getAttendance };
